/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_Projects_Wizard_SubtitleInputs */



/**
* | output |
* | --- |
* | "Optionally choose projects that should use this resource. You can change this later in the space settings." |
*
* @param {Linked_Projects_Wizard_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const linked_projects_wizard_subtitle = /** @type {((inputs?: Linked_Projects_Wizard_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_Projects_Wizard_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wähle optional Projekte aus, die diese Ressource nutzen sollen. Du kannst das später in den Space-Einstellungen ändern.")
	return /** @type {LocalizedString} */ ("Optionally choose projects that should use this resource. You can change this later in the space settings.")
});